module.exports = __webpack_public_path__ + "4bad662132361867b9778c590c5bf913.pdf";